angular.module('picmonic-common').directive('groupBuySmsAlertsOptin', function () {
  return {
    restrict: 'E',
    replace: true,
    template:
      '<div class="group-buy-sms-alert m-b-2">\n' +
      '        <div>' +
      '            <form name="phoneForm">' +
      '                <input type="text" mask="(999) 999-9999" clean="true" ng-model="phone" class="pls-input pls-input--light pls-btn--gradient-blue-small m-r-2" placeholder="Phone number" style="max-width: 264px;" />\n' +
      '                <a class="pls-btn pls-btn--gradient-blue" ng-click="submit()" ng-disabled="loading"><span ng-show="!loading">Submit</span><span ng-show="loading"><pls-loading-icon></pls-loading-icon></span></a>\n' +
      '            </form>' +
      '        </div>' +
      '        <div class="m-t-2 text-center" ng-show="message || error">' +
      '            <div ng-show="error" class="pls-mugatu">{{error}}</div>' +
      '            <div ng-show="messageTitle"><strong>{{messageTitle}}</strong></div>' +
      '            <div ng-show="message">{{message}}</div>' +
      '        </div>' +
      '    </div>',
    scope: {
      onSuccess: '&',
    },
    controller: [
      '$scope',
      'User',
      function ($scope, User) {
        $scope.phone = '';
        $scope.submit = function () {
          if ($scope.loading) {
            return;
          }

          if ($scope.phoneForm.$pristine || !$scope.phoneForm.$valid) {
            $scope.error = 'Please enter a valid phone number.';
            return;
          }

          $scope.error = '';
          $scope.messageTitle = '';
          $scope.message = '';
          $scope.loading = true;

          User.updatev3(
            {
              resource: 'group_buy',
              resource_id: 'alerts',
              phone: $scope.phone,
            },
            function () {
              $scope.messageTitle = 'Success!';
              $scope.message = "We've sent a message to your phone. Thanks!";
              $scope.loading = false;
              atlasEvent('submit', 'group buy sms alerts optin');
              if ($scope.onSuccess) {
                $scope.onSuccess();
              }
            },
            function (error) {
              $scope.error =
                error.data && error.data.message
                  ? error.data.message
                  : 'There was an error. Double check your phone number and try again.';
              $scope.loading = false;
            }
          );
        };
      },
    ],
  };
});
